import { UserRole } from 'context';

/**
 * ТЗ 0074: поп-ап неоплаченных фактур — «раз за вход».
 *
 * Флаг живёт в sessionStorage и ключуется id пользователя: иначе следующий
 * студент, вошедший в той же вкладке, поп-ап бы не увидел. «Вход» закрывает
 * logout — он стирает все такие флаги (clearUnpaidInvoicesModalFlags), и
 * следующий вход показывает поп-ап заново. Перезагрузка страницы входом не
 * считается: флаг переживает её, как и сама сессия вкладки.
 */
export const UNPAID_INVOICES_MODAL_KEY_PREFIX = 'tms_unpaid_invoices_modal_shown:';

export const unpaidInvoicesModalSessionKey = (userId: string) =>
  `${UNPAID_INVOICES_MODAL_KEY_PREFIX}${userId}`;

const safeStorage = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};

export const markUnpaidInvoicesModalShown = (userId: string) => {
  safeStorage()?.setItem(unpaidInvoicesModalSessionKey(userId), '1');
};

export const wasUnpaidInvoicesModalShown = (userId: string): boolean =>
  Boolean(safeStorage()?.getItem(unpaidInvoicesModalSessionKey(userId)));

export const clearUnpaidInvoicesModalFlags = () => {
  const storage = safeStorage();
  if (!storage) {
    return;
  }
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key?.startsWith(UNPAID_INVOICES_MODAL_KEY_PREFIX)) {
      keys.push(key);
    }
  }
  keys.forEach((key) => storage.removeItem(key));
};

interface IUnpaidInvoicesModalInput {
  userId: string | null;
  activeRole: string | null;
  unpaidInvoicesCount: number;
  isSuspended: boolean;
}

/**
 * Поп-ап положено показать сейчас: студент, есть неоплаченные, доступ НЕ
 * приостановлен (у приостановленного есть красная область на /invoices, поп-ап
 * поверх неё — лишний шум) и в этом входе ещё не показывали.
 *
 * Отдельной функцией, потому что тот же вопрос задаёт опросный поп-ап: он
 * уступает очередь, пока фактурный ещё не показан.
 */
export const isUnpaidInvoicesModalDue = ({
  userId,
  activeRole,
  unpaidInvoicesCount,
  isSuspended,
}: IUnpaidInvoicesModalInput): boolean =>
  activeRole === UserRole.STUDENT &&
  unpaidInvoicesCount > 0 &&
  !isSuspended &&
  Boolean(userId) &&
  !wasUnpaidInvoicesModalShown(userId as string);
